import React, {
  RefObject,
} from 'react';
import Table from 'core/components/VirtualTable';
import {
  FaxContactDTO,
} from 'dtos';
import columns from 'pages/Dashboard/pages/Contacts/columns';
import {
  VirtualTableInstance,
} from 'core/components/VirtualTable/types';
import {
  getContactsData,
} from 'pages/Dashboard/pages/Fax/transport';
import {
  faxEventChannel,
} from 'pages/Dashboard/services/eventChannels';

type ListQueryProps = {
  searchQuery?: string;
  tableInstanceRef?: RefObject<VirtualTableInstance>;
};

export default function QueryTable({ searchQuery, tableInstanceRef }: ListQueryProps) {
  return (
    <Table<FaxContactDTO>
      instanceRef={tableInstanceRef}
      onRowClick={(_table, row) => {
        faxEventChannel.emit('onOpenContacts', row?.original);
      }}
      getData={getContactsData}
      queryParams={{
        searchQuery,
      }}
      getRowId={(row) => row?.faxContactId ?? ''}
      columns={columns}
      emptySlot="No Contacts Found"
      classes={{
        header: 'px-4',
        scrollContainer: 'justify-center items-center',
        outerRow: '!w-[calc(100%-16px)] left-4',
        row: 'py-1',
      }}
      defaultPagination={{
        pageSize: 25,
        pageIndex: 0,
      }}
    />
  );
}
